export default __webpack_public_path__ + "static/media/restaurant_1.8a882d32.jpg";